import styled from 'styled-components';

import { breakPoints } from '~/src/constants/breakpoints';

export const VideoWrap = styled.div<{isChromium?: boolean}>`
    width: 100%;
    background-image: url(${require('~/static/images/movix-new/bg-light.png')});
    background-position: 90% 70%;
    background-repeat: no-repeat;
    
    @media (max-width: ${breakPoints.desktop}) {
        background-image: none;
    }

    video, img {
        position: relative;
        top: -30%;
        width: 48%;
        padding: 2.2% 0.7% 5.7% 8.9%;
        left: 40%;
        
        @media (max-width: ${breakPoints.desktop}) {
            left: 33%;
            width: 63.7%;
            top: -22%;
            padding: 2.2% 0 6% 8.9%;
        }
        
        @media (max-width: ${breakPoints.sDesktop}) {
            width: 65%;
            left: ${p => p.isChromium ? '53.5%' : '54%'};
            padding: 2.2% 0 5.5% 8.9%;
        }
        
        @media (max-width: ${breakPoints.tablet}) {
            width: 100%;
            padding: 3% 3.2% 2.3% 3.5%;
            top: -24%;
            left: ${p => p.isChromium ? '0' : '-13px'};
        }
    }
`;
